import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const TrackYourArticle = () => {
    const [reference, setReference] = useState('');
    const [trackedArticle, setTrackedArticle] = useState(null);
    const [loading, setLoading] = useState(false);


    const handleTrack = async () => {
        if (!reference) {
            toast.error("Please enter a reference number to proceed.");
            return;
        }

        setLoading(true); // show spinner

        try {
            const response = await fetch(`https://backend.impactjournal.co.in/manuscript/track/${reference}`);
            if (!response.ok) throw new Error("Article not found");
            const data = await response.json();
            setTrackedArticle(data);
        } catch (err) {
            setTrackedArticle(null);
            toast.error("No article found for this reference number.");
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            {/* <ToastContainer position="top-center" autoClose={3000} /> */}
            <div className="tya-wrapper-impact">
                <h2 className="tya-heading-impact">Track Your Article</h2>
                <div className="tya-conatiner-pm">
                    <div className="tya-procedure-to-track-pm">
                        <div className="tya-tracking-container-pm">
                            <p>
                                Enter your reference number to track your article and get notified by email once it's published.
                            </p>

                            <div className="tya-input-track-pm">
                                <input type="text" className="tya-input-track" placeholder="Enter your reference number" value={reference}
                                    onChange={(e) => setReference(e.target.value)} />
                            </div>
                            <div className="tya-track-btn-pm">
                                <button className="tya-track-btn" onClick={handleTrack} disabled={loading}>
                                    {loading ? <span className="spinner"></span> : "Track Article"}
                                </button>
                            </div>
                        </div>
                        {trackedArticle && (
                            <div className="about-ed-block-impact">
                                <div className="about-ed-role-impact">Article Tracking Table</div>
                                <div className="about-ed-table-container-impact">
                                    <table className="about-ed-table-impact">
                                        <thead>
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Author</th>
                                                <th>Title</th>
                                                <th>Status</th>
                                                <th>Payment Status</th> {/* Added Payment Status column */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1.</td>
                                                <td>{trackedArticle.name}</td>
                                                <td>{trackedArticle.articleTitle}</td>
                                                <td>{trackedArticle.statusOptions || 'N/A'}</td>
                                                <td>{trackedArticle.pay_status || 'Unpaid'}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default TrackYourArticle;
